<template>
  <v-toolbar flat dense color="rgba(0,0,0,.1)" class="colorToolBarMarkets">
    <div class="row no-gutters">
      <v-col
        :class="[
          $route.query.event ? 'col-md-6 col-lg-6' : 'col-md-3 col-lg-4',
        ]"
        class="d-flex align-center overflow-hidden col-sm-6 col"
      >
        <img
          v-if="toolbarIconSport"
          class="mb-0"
          width="24px"
          :src="toolbarIconSport"
        />
        <iconSport v-else :idSport="idSport" />
        <v-toolbar-title class="subtitle-1 ml-3">
          {{ sportName }}
        </v-toolbar-title>
      </v-col>

      <v-col
        :class="[
          $route.query.event ? 'col-md-6 col-lg-5' : `col-md-8 col-lg-8`,
        ]"
        class="d-flex align-center text-center col-sm-6 col overline"
      >
        <div class="row no-gutters justify-end">
          <v-col
            class="pl-2"
            :cols="12 / idMarkets.length"
            v-for="(market, indexReplace) in idMarkets"
            :key="`${market.name_market}-${indexReplace}` + [Math.random()]"
          >
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-card
                  v-on="on"
                  flat
                  class="py-1 c-custom-h text-truncate px-2 caption"
                  :style="{
                    margin: $vuetify.breakpoint.xsOnly
                      ? '0 0 0 5px !important'
                      : '0 0px 0 0px !important',
                    background: 'rgba(255,255,255,0.07)',
                  }"
                >
                  {{ market.name_market }} <v-icon>mdi-menu-down</v-icon>
                </v-card>
              </template>
              <v-list>
                <v-list-item-group
                  v-model="selected[indexReplace]"
                  color="primary"
                >
                  <v-list-item
                    v-for="item in itemsDropdows"
                    :key="item.id_market + [Math.random()]"
                    @click="selectMarket(item, indexReplace)"
                    :disabled="isSelected(item.id_market)"
                  >
                    <v-list-item-title style="font-size: 14px">
                      {{ item.name_market }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </v-col>
        </div>
      </v-col>

      <!-- <v-col v-if="$vuetify.breakpoint.smAndDown || $route.query.event" class="d-flex align-center justify-center overline text--secondary col-md-1 col">
        <v-card flat class="text-center pa-1 px-2 mx-3 py-2">mais</v-card>                            
      </v-col> -->
    </div>
  </v-toolbar>
</template>

<script>
import iconSport from "@/components/icon-sport/";
import {
  selectMarketTable,
  marketsDropdown,
  storeInfos,
} from "@/util/menuTable.js";
import { mapState } from "vuex";
export default {
  name: "toolbar-tab-markets",
  props: ["type", "sportNameInBt"],
  components: {
    iconSport,
  },
  data: () => {
    return {
      sportsNavTabs: [],
      toolbarIconSport: "",
      selected: [0, 1, 2, 3, 4, 5],
      // sport: ''

      selectedMarkets: [],
    };
  },
  async mounted() {
    storeInfos();
    this.sportsNavTabs = await this.$handlerIconsImgSports(
      this.$store.state.sports
    );
    this.updateToolbarIconSport();
  },
  computed: mapState({
    sportName: function() {
      let sportName;
      if (this.type === "nextEvents") {
        sportName = this.$route.query.sport;
      }
      if (this.type === "live") {
        if (this.$route.params.event) {
          sportName = this.$route.query.sport;
        } else {
          sportName = this.$route.query.live;
        }
      }
      if (this.type === "bigTable") {
        sportName =
          this.sportNameInBt || this.$store.getters.getNameSportById("6046");
      }

      return sportName;
    },

    // Recupera o Id do Esporte pela Query sport selecionada com o suporte do Store infoTable
    idSport() {
      return this.$store.getters.getIdSportByName(this.sportName);
    },

    idMarkets: function() {
      let breakpoint = this.$vuetify.breakpoint.name;
      let event = this.type === "bigTable" ? false : this.$route.params.event;

      return this.$store.getters.getIdMarkets(
        this.idSport,
        breakpoint,
        event,
        this.type
      );
    },

    itemsDropdows: function() {
      return marketsDropdown(this.idSport);
    },
    /*
      Recuperando state do languages para
      corrigir comportamento do select de mercados
    */
    language() {
      return this.$store.state.language;
    },
  }),
  watch: {
    idSport() {
      this.updateToolbarIconSport();
    },
    language() {
      /*
      Fix no comportamento do select de mercados
      reseta o componente para o estado inicial quando altera
      o idioma
      */
      this.selected = [0, 1, 2, 3, 4, 5];
    },
  },
  methods: {
    selectMarket(item, iReplace) {
      selectMarketTable(this.idSport, item, iReplace, this.type);
    },

    updateToolbarIconSport() {
      this.toolbarIconSport = this.sportsNavTabs.find(
        (sport) => this.idSport == sport.id_sport
      ).icon_img;
    },

    isSelected(marketId) {
      return !!this.idMarkets.find(({ id_market }) => id_market === marketId);
    },
  },
};
</script>
